export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-secondary-500 to-secondary-700 rounded-2xl p-8 md:p-12 text-center">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-background-50/20 text-background-50 mb-4 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-4">
            内容合作 · 问题反馈
          </h2>
          <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-8 max-w-[600px] mx-auto">
            如果您有内容合作需求、版权问题咨询或观影体验反馈，欢迎通过以下方式与我们取得联系。窝窝影院致力于为用户提供高清播放在线不缓冲的优质服务，您的每一条建议我们都认真对待。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <span className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50 text-secondary-700 font-semibold text-sm cursor-pointer hover:bg-background-100 transition-colors">
              <i className="ri-mail-line text-lg"></i>
              商务合作
            </span>
            <span className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/15 text-background-50 font-semibold text-sm border border-background-50/30 cursor-pointer hover:bg-background-50/25 transition-colors">
              <i className="ri-feedback-line text-lg"></i>
              用户反馈
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}